module.exports = __webpack_public_path__ + "img/8.ba95bb9d.png";